import { PageSizeType } from "@/app/model/types";
import { CartSliceState } from "./types";
import { nomenclaturePath } from "./types";

export const initialState: CartSliceState = {
  totalCount: 0,
  error: null,
  isLoading: false,

  productionItems: [],
  selectedProdItems: [],
  allProdIds: [],
  allBasketProdIds: [],
  allFilialsProdIds: [],
  totalProdPrice: 0,
  totalProdCount: 0,
  isLoadingProd: false,

  remainsItems: [],
  selectedRemainsItems: [],
  allRemainsIds: [],
  allBasketRemainsIds: [],
  allFilialsRemainsIds: [],
  totalRemainsPrice: 0,
  totalRemainsCount: 0,
  isLoadingRemain: false,

  dealerRemainsItems: [],
  hasDealerRemainsCart: false,
  isLoadingDealerRemain: false,
  totalDealerRemainsCount: 0,
  dealerRemainsPageSize:
    (+localStorage.getItem("psizeCartD") as PageSizeType) || 20,
  dealerRemainsPageNumber:
    (+localStorage.getItem("pnumCartD") as PageSizeType) || 1,
  dealerRemainsTotalPageNumber: 1,
  dealerRemainsSort: null,
  collapsedDealerRemainsIds: [],
  selectedDealerRemainsBasketIds: [],
  newDealerRemainsOrder: null,

  totalCartCount: 0,

  newRemainsOrder: null,
  from: nomenclaturePath,
  excludeItems: ["basketFilials"],
  mainFilial: null,
  filalsProdIdsToShow: [],
  filalsRemainsIdsToShow: [],

  dealersProdIdsToShow: [],
  dealersRemainsIdsToShow: [],

  canCreateOrder: true,
  deleteMode: false,

  productionOrder: {
    type: "desc",
    field:
      "brand,figureNumber,modelName,width,diameter,discOffset,drilling,diameterOfCenteringHoles,diameterWheelHub,color",
  },
  remainsOrder: {
    type: "desc",
    field:
      "brand,figureNumber,modelName,width,diameter,discOffset,drilling,diameterOfCenteringHoles,diameterWheelHub,color",
  },
  productionPageSize:
    (+localStorage.getItem("psizeCartP") as PageSizeType) || 20,
  remainsPageSize: (+localStorage.getItem("psizeCartR") as PageSizeType) || 20,
  productionPageNumber:
    (+localStorage.getItem("pnumCartP") as PageSizeType) || 1,
  remainsPageNumber: (+localStorage.getItem("pnumCartR") as PageSizeType) || 1,
  productionTotalPageNumber: 1,
  remainsTotalPageNumber: 1,

  productionDefaultOrder: {
    type: "desc",
    field:
      "brand,figureNumber,modelName,width,diameter,discOffset,drilling,diameterOfCenteringHoles,diameterWheelHub,color",
  },
  remainsDefaultOrder: {
    type: "desc",
    field:
      "brand,figureNumber,modelName,width,diameter,discOffset,drilling,diameterOfCenteringHoles,diameterWheelHub,color",
  },

  productionFilters: [],
  remainsFilters: [],
  selectedProductionFilters: {},
  selectedRemainsFilters: {},
  filtersLoading: false,
  filtersError: null,

  productionFilterItems: {},
  remainsFilterItems: {},
};
